import { render } from "./PayPopUpLoader.vue?vue&type=template&id=382722ed"
import script from "./PayPopUpLoader.vue?vue&type=script&lang=js"
export * from "./PayPopUpLoader.vue?vue&type=script&lang=js"

import "./PayPopUpLoader.vue?vue&type=style&index=0&id=382722ed&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__